import ThemeCard from "./ThemeCard";

export default function ThemeSelectionStep({ themes, form, updateField }) {
    return (
        <div>
            <h2 className="wg-section-title">Theme Selection</h2>
            <p className="wg-section-subtitle">
                Pick the visual style. Layout and structure will adapt automatically based on your business type.
            </p>

            <div className="wg-theme-grid">
                {themes.map((theme) => (
                    <ThemeCard
                        key={theme.key}
                        theme={theme}
                        selected={form.themeKey === theme.key}
                        onClick={() => updateField("themeKey", theme.key)}
                    />
                ))}
            </div>
        </div>
    );
}